import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux'
import {
    ajaxFeedbackStatusFilter,
    ajaxFeedbackSearch,
    setSearchTimerInterval,
    IncrementSearchTyping,
    setQuery,
    setLoading,
    setFeedbackStatus
} from './redux/FeedbackRedux';

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: this.props.search
        };
    }

    handleClick(event) {
        event.preventDefault();
        let timeframe = this.props.timeframe;
        let sorting = this.props.sorting;
        let prev = jQuery('.previous-date').val();
        let next = jQuery('.next-date').val();
        let dateObject = null;

        if (prev && next) {
            dateObject = {prev: prev ?? null, next: next ?? null};
        }
        let status = event.target.id;
        this.props.dispatch(setFeedbackStatus(status));

        window.dashboard_filter_status = status;

        if (!this.props.businesses) {
            this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, status, null, null, null, this.props.excludeStatistics));
        } else {
            let ids = [];
            for (let i in this.props.businesses) {
                ids.push(this.props.businesses[i].business_id);
            }
            this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, status, null, null, null, this.props.excludeStatistics));
        }
    }

    handleChange() {
        this.setState({searchText: this.refs.searchInput.value});
    }

    handleSearch() {
        if (window.search_timer_started == false) {
            this.props.dispatch(setSearchTimerInterval());
            window.search_timer_started = true;
        }
        this.props.dispatch(IncrementSearchTyping(true));
        let timeframe = this.props.timeframe;
        let status = this.props.status;
        let searchType = "chat";
        if (this.props.searchType && this.props.searchType !== "chat") {
            searchType = this.props.searchType;
        }
        let business_id_or_ids = this.props.business_id;
        if (this.props.businesses) {
            let ids = [];
            for (let i in this.props.businesses) {
                ids.push(this.props.businesses[i].business_id);
            }
            business_id_or_ids = ids;
        }
        let self = this;
        this.props.dispatch(setLoading({loading: true, location: 'search'}));

        let prev = jQuery('.previous-date').val();
        let next = jQuery('.next-date').val();

        let dateObject = null;

        if (prev && next) {
            dateObject = {prev: prev ?? null, next: next ?? null};
        }

        if (this.refs.searchInput.value.length > 0) {
            this.props.dispatch(setQuery(this.state.searchText));
        } else {
            this.props.dispatch(setQuery(null));
        }

        if (searchType === "chat") {
            self.props.dispatch(ajaxFeedbackSearch(this.props.state));
        } else {
            setTimeout(() => {
                this.props.dispatch(ajaxFeedbackStatusFilter(this.props.state, null, null, null, null, this.props.excludeStatistics));
            }, 100);
        }
    }

    handleResetSearch() {
        this.refs.searchInput.value = '';
        this.setState({searchText: ''});
        this.props.dispatch(setQuery(null));

        if (this.props.query.length > 0) {
            this.handleSearch();
        }
    }

    componentDidMount() {
        window.search_timer_started = false;
        window.dashboard_filter_status = this.props.status;
    }

    render() {
        let timestring = "";
        if (this.props.timeframe === "today") {
            timestring = __("From Today");
        } else if (this.props.timeframe === "yesterday") {
            timestring = __("From Yesterday");
        } else if (this.props.timeframe === "weekToDate") {
            timestring = __("From This Week");
        } else if (this.props.timeframe === "monthToDate") {
            timestring = __("From This Month");
        } else if (this.props.timeframe === "lifetime") {
            timestring = __("From All-Time");
        } else if (this.props.timeframe === "last30") {
            timestring = __("From Last 30 Days");
        }

        return (
            <div className="col-md-12 p-0">
                <div className="card card-search">
                    <div className="title-row make-even d-flex align-items-center">
                        <div
                            className="card-title card-title-end col-lg-2 tab ml-auto border-left border-right-0 justify-content-center">
                            <div className="dropdown">
                                <button className="btn btn-card dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {this.props.status != null && this.props.status != "null" ? this.props.status : __("All")} {' '} { __('Feedbacks') }
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a className="dropdown-item" onClick={this.handleClick.bind(this)} id={window.feedbackStatus.Open.value} href="#">{window.feedbackStatus.Open.label}</a>
                                    <a className="dropdown-item" onClick={this.handleClick.bind(this)} id={window.feedbackStatus.Pending.value} href="#">{window.feedbackStatus.Pending.label}</a>
                                    <a className="dropdown-item" onClick={this.handleClick.bind(this)} id={window.feedbackStatus.Resolved.value} href="#">{window.feedbackStatus.Resolved.label}</a>
                                    <a className="dropdown-item" onClick={this.handleClick.bind(this)} id="All" href="#">{ __('All') }</a>
                                    {this.props.state.businessHasAutoPilot && <a className="dropdown-item" onClick={this.handleClick.bind(this)} id={window.feedbackStatus.RatingsOnly.value} href="#">{window.feedbackStatus.RatingsOnly.label}</a>}
                                </div>
                            </div>
                        </div>
                        <div className="card-title tab col-lg-4 justify-content-center search-bar-title">
                            <h5 className="text-primary">
                                {(this.props.status != null && this.props.status != "null" ? this.props.status : __("All")) + ' ' +  __("Feedbacks") + ' ' + timestring}
                                {(this.props.totals && this.props.totals?.count > 0) && <span>&nbsp;({this.props.totals.count})</span>}
                            </h5>
                        </div>
                        <div className="card-title col-sm px-2 pr-0 search-bar-search">
                            <form className="input-group feedback-form-control mb-0" onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSearch.bind(this);
                            }}>
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><i className="fas fa-search"></i></span>
                                </div>
                                <input type="text" className="form-control pl-0" placeholder={ __('Search Feedbacks') + '...' }
                                       defaultValue={this.state.searchText} onChange={this.handleChange.bind(this)}
                                       aria-label={__("Search Feedbacks") + '...'} ref="searchInput" id="search_text"/>
                                {this.state.searchText.length > 0 && <span className="btn mr-1 cursor-point" onClick={this.handleResetSearch.bind(this)}>&times;</span>}
                                <button type="submit" className="btn btn-primary" onClick={this.handleSearch.bind(this)}>{ __('Search') }</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        totals: state.totals,
        archive: state.archive,
        department_ids: state.department_ids ?? null,
        other_filter: state.other_filter,
        total: state.total_pages,
        status: state.status,
        query: state.query,
        timeframe: state.timeframe,
        feedback_id: (state.selected_feedback ?? null),
        businesses: (state.businesses ?? null),
        business_id: (state.business ? state.business.business_id : (state.feedback_detail ? state.feedback_detail.business_id : null)),
        timer: state.search_typing_timer,
        search: state.query
    }
}

export default connect(mapStateToProps)(SearchBar)
